module.exports = __webpack_public_path__ + "img/rdn.04580a6c.svg";